import React, {Component} from "react";
import {connect} from "react-redux";
import {Layout} from "antd";
import SidebarContent from "./SidebarContent";
import { isShoperApp } from "../../util/appType";
import { hideLeftSidebar, switchLanguage } from "../../appRedux/actions";
import { getSidebarCollapsed, setSidebarCollapsed } from "../../util/uiPreferences";

const {Sider} = Layout;
const DESKTOP_BREAKPOINT = isShoperApp() ? 0 : 992;
const SHOPER_FOLD_WIDTH = 1100;

export class Sidebar extends Component {
  state = {
    width: window.innerWidth,
    collapsed: getSidebarCollapsed(),
  };

  toggleCollapsed = () => {
    const collapsed = !this.state.collapsed;
    setSidebarCollapsed(collapsed);
    this.setState({collapsed});
  };

  updateWindowDimensions = () => {
    this.setState({width: window.innerWidth});
  };

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  isShoperMenuHidden =() => isShoperApp() && ['my-archives', 'chat'].includes(this.props.pathname.substr(1))

  render() {
    const {shouldShowLeftSidebarMobile} = this.props.global;
    const {width} = this.state;

    const isDesktop = width >= DESKTOP_BREAKPOINT;
    // Folding only applies on desktop; on mobile the sidebar is an overlay drawer.
    // In Shoper (an iframe beside Shoper's own menu) it folds to icons by itself when narrow.
    const autoCollapsed = isShoperApp() && width < SHOPER_FOLD_WIDTH;
    const collapsed = isDesktop && (autoCollapsed || this.state.collapsed);

    let drawerStyle = "gx-app-sidebar gx-layout-sider-dark my-sidebar--dark";
    if (collapsed) {
      drawerStyle += " my-sidebar--collapsed";
    }
    if (!isDesktop) {
      drawerStyle += shouldShowLeftSidebarMobile ? " sidebar-left-overlay" : " hide";
    }

    // Tap-outside-to-close backdrop for the mobile drawer (all pages).
    const showBackdrop = !isDesktop && !isShoperApp() && shouldShowLeftSidebarMobile;

    return (
      <>
      {showBackdrop && <div className="sidebar-backdrop" onClick={this.props.hideLeftSidebar}/>}
      <Sider
          id="my-sidebar"
          className={drawerStyle}
          theme="dark"
          collapsed={collapsed}
          width={232}
          collapsedWidth={72}
          trigger={null}
          style={{display: this.isShoperMenuHidden() ? 'none' : 'block'}}
      >
        <SidebarContent collapsed={collapsed} canCollapse={isDesktop && !autoCollapsed} onToggleCollapsed={this.toggleCollapsed}/>
      </Sider>
      </>
    )
  }
}

const mapStateToProps = (state) => ({
  global: state.global,
  messages: state.messages,
  pathname:  state.settings.pathname
});
export default connect(mapStateToProps, {switchLanguage, hideLeftSidebar})(Sidebar);
